import { DISTRICTS } from '@/domains/partners/multisport/const/Districts.const'

export const useDistricts = () => {
  const { t } = useI18n()
  return DISTRICTS.map((district: { text: string }) => ({
    ...district,
    text: t(district.text),
  }))
}
